@if (initialized) {


    <p-tabs [(value)]="activeIndex" (valueChange)="onTabChange($event)">
        <p-tablist>
            @for (tab of tabs; track tab) {
                <p-tab [value]="tab.key">{{ tab.label }}</p-tab>
            }
        </p-tablist>

        <p-tabpanels>
            @for (tab of tabs; track tab) {

                <p-tabpanel [value]="tab.key">

                    @switch (tab.key) {

                        @case ('call') {
                            @if (currentView == 'call') {
                                <mvs-object-inline
                                        [objectType]="objectIdentifier.objectType"
                                        [objectId]="objectIdentifier.objectId">
                                </mvs-object-inline>

                                <mvs-call-dial [calledObject]="objectIdentifier"></mvs-call-dial>

                                @if (objectCallsWidget) {
                                    <mvs-widget [widgetData]="objectCallsWidget"></mvs-widget>
                                }
                            }
                        }
                        @case ('address') {
                            @if (currentView == 'address') {
                                <div class="grid">
                                    @if (addresses) {
                                        <div class="col-12">
                                            <div class="flex justify-content-between align-items-center w-full">
                                                <label class="font-medium w-full">Address</label>
                                                <p-select
                                                        [options]="addresses"
                                                        [(ngModel)]="selectAddress"
                                                        optionValue="addressDtoId"
                                                        optionLabel="addressDtoName"
                                                        placeholder="Select Address"
                                                        class="w-full"
                                                        styleClass="w-full"
                                                        appendTo="body"
                                                        (onChange)="addressId = selectAddress">
                                                </p-select>
                                            </div>
                                        </div>
                                    }

                                    @if (addressWidget) {
                                        <div class="col-12">
                                            <mvs-widget
                                                    [widgetData]="addressWidget"
                                                    (onChangedObject)="handleAddressCreation($event)">
                                            </mvs-widget>
                                        </div>
                                    }

                                    <div class="col-12">
                                        <div class="flex justify-content-between align-items-center mb-2">
                                            <span class="font-semibold">New location for only this Appointment?</span>
                                            <div class="flex align-items-center gap-2">
                                                <p-toggle-switch [(ngModel)]="createAddress"></p-toggle-switch>
                                            </div>
                                        </div>

                                        @if (addressObjectWidget && createAddress) {
                                            <mvs-widget
                                                    [widgetData]="addressObjectWidget"
                                                    (onChangedObject)="handleAddressCreation($event)">
                                            </mvs-widget>
                                        }
                                    </div>
                                </div>
                            }
                        }
                        @case ('appointment') {
                            @if (currentView == 'appointment') {
                                @if (agents) {
                                    TODO: as-free-slot does not belong in here!
<!--                                    <as-free-slot-->
<!--                                            [agents]="agents"-->
<!--                                            [addressId]="addressId"-->
<!--                                            [addressName]="addressName"-->
<!--                                            [objectIdentifier]="objectIdentifier"-->
<!--                                            [appointmentTypeId]="appointmentTypeId"-->
<!--                                            [hideSelectionHeader]="hideSelectionHeader"-->
<!--                                            [customerName]="name"-->
<!--                                            (onAppointmentCreate)="handleAppointmentCreate($event)"-->
<!--                                            [referenceObjectTypeAlias]="ticketActionIdentifier.objectType"-->
<!--                                            [referenceObjectId]="ticketActionIdentifier.objectId">-->
<!--                                    </as-free-slot>-->
                                }
                            }
                        }

                    }
                </p-tabpanel>
            }
        </p-tabpanels>
    </p-tabs>

}